import React from 'react';
import { Zap } from 'lucide-react';

export const ForcedUnknownButton = ({ onClick, disabled, cooldown }) => {
  return (
    <div className="space-y-2" data-testid="forced-unknown-wrapper">
      <span className="text-xs uppercase tracking-widest font-mono text-zinc-400">
        Interrupt
      </span>
      <button
        onClick={onClick}
        disabled={disabled || cooldown}
        className={`
          w-full flex items-center justify-center gap-2
          bg-orange-600 text-white hover:bg-orange-700
          rounded-sm px-5 py-3.5 font-bold uppercase tracking-wider text-sm
          shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]
          hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]
          active:translate-y-[4px] active:shadow-none
          transition-all duration-150
          disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none disabled:translate-y-0
          ${!cooldown && !disabled ? 'btn-shake' : ''}
        `}
        data-testid="forced-unknown-btn"
      >
        <Zap size={18} />
        {cooldown ? 'Cooling...' : 'Force Unknown'}
      </button>
      <p className="text-xs text-zinc-400 leading-relaxed">
        Random chaos: scatter, void burst, warp, shuffle, or inject.
      </p>
    </div>
  );
};
